import { AnyAction, isType } from 'typescript-fsa/dist/typescript-fsa';
import { BettingUser } from '../../services/betting';
import { userLinkSet, userLinkSetUserImage } from './actions';

export interface UserLinkState {
    userInfos: { [userId: string]: BettingUser };
    userImages: { [userId: string]: string };
}

const initialUserLinkState: UserLinkState = {
    userInfos: {},
    userImages: {}
};

export function userLinkReducer(state: UserLinkState = initialUserLinkState, action: AnyAction): UserLinkState {
    if (isType(action, userLinkSet)) {
        const { userInfos } = state;
        userInfos[action.payload.id] = action.payload;
        return { ...state, userInfos };
    } else if (isType(action, userLinkSetUserImage)) {
        const { userImages } = state;
        if (action.payload.imageId) {
            userImages[action.payload.userId] = action.payload.imageId;
        }
        return { ...state, userImages };
    }
    return state;
}
